import React from 'react';

import moment from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { VehiclePick } from 'models/auto/vehicle';

import AutoDetailMap from './components/AutoDetailMap';
import {
  Container,
  Content,
  Address,
  StyledButton as Button,
  Map,
  Icon,
  IconPickUp,
  IconDropOff,
  IconDate,
} from './styles';

export interface Props {
  data: VehiclePick;
  isPickUp?: boolean;
  hasAgencies?: boolean;
  onClick?: (isPickUp: boolean) => void;
}
const AutoDetailPlace = ({ data, isPickUp = true, hasAgencies = false, onClick }: Props) => {
  const { t } = useStoreTranslation();
  const title = isPickUp ? t('autosDetails.pickUp') : t('autosDetails.dropOff');
  const placeLocation = data.address;
  const placeDate = moment(data.time?.replace('Z', '')).format('ddd DD, MMM');
  const placeTime = moment(data.time?.replace('Z', '')).format('hh:mm A');
  const center = data.latitude && data.longitude ? { lat: data.latitude, lng: data.longitude } : { lat: 0, lng: 0 };
  const showMap = false;

  return (
    <Container>
      <Content $hasMap={showMap}>
        <Content.Title>{title}</Content.Title>
        <Address>
          <Address.Item>
            <Address.Icon>{isPickUp ? <IconPickUp /> : <IconDropOff />}</Address.Icon> {placeLocation}
          </Address.Item>
          <Address.Item>
            <Address.Icon>
              <IconDate />
            </Address.Icon>
            {placeDate}
            <Address.Image>
              <Icon src="/images/autos/icon-clock.svg" />
            </Address.Image>
            {placeTime}
          </Address.Item>
        </Address>
        {hasAgencies ? (
          <Button
            onClick={() => {
              if (onClick) onClick(isPickUp);
            }}
          >
            {t('autosDetails.changeStore')}
          </Button>
        ) : null}
      </Content>
      {showMap ? (
        <Map>
          <AutoDetailMap mapCenter={center} show={showMap}></AutoDetailMap>
        </Map>
      ) : null}
    </Container>
  );
};

export default AutoDetailPlace;
